export default __webpack_public_path__ + "static/media/thumbnail.bed46ece.webp";